// src/pages/club/settings/api/ClubProviderAPI.js
import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class ClubProviderAPI {
  URI_V1 = "/v1/club/providers";

  getCompanyId() {
    const cm = companyAPI.getCompanyManagment();
    return cm?.id;
  }

  connectMercadoPago = async () => {
    const companyId = this.getCompanyId();
    return await apiService.post(
      `${this.URI_V1}/mercado-pago/connect/start?companyId=${companyId}`,
      null
    );
  };

  getMercadoPagoStatus = async () => {
    const companyId = this.getCompanyId();
    return await apiService.get(
      `${this.URI_V1}/mercado-pago/status?companyId=${companyId}`
    );
  };

  disconnectMercadoPago = async () => {
    const companyId = this.getCompanyId();
    return await apiService.post(
      `${this.URI_V1}/mercado-pago/disconnect?companyId=${companyId}`,
      null
    );
  };
}
